import React from 'react';
import styled from 'styled-components';

interface CalculationResultProps {
  value: string;
}

export const CalculationResult = ({
  value,
}: CalculationResultProps): JSX.Element => {
  return (
    <CalculationResultWrapper aria-live="polite">
      {value}
    </CalculationResultWrapper>
  );
};

const CalculationResultWrapper = styled.div`
  &:not(:focus, :active) {
    position: absolute;
    width: 1px;
    height: 1px;
    overflow: hidden;
    clip: rect(0 0 0 0);
    clip-path: inset(50%);
    white-space: nowrap;
  }
`;
